import React from "react";

import { ExperienceDto } from "@intelligems/ig-types";
import { useIsMutating } from "@tanstack/react-query";

import { ActionExperienceButton } from "./ActionExperienceButton";

interface HaltExperienceButtonProps {
  rowExperience: ExperienceDto;
  currentExperience?: ExperienceDto;
  onActionExpButtonClick: (experiment: ExperienceDto) => void;
  action: "pause" | "end";
}
export const HaltExperienceButton = ({
  rowExperience,
  currentExperience,
  onActionExpButtonClick,
  action,
}: HaltExperienceButtonProps) => {
  const isStartExperimentMutating = useIsMutating({
    mutationKey: ["startExperience"],
  });
  const isEndExperimentMutating = useIsMutating({
    mutationKey: ["endExperience"],
  });
  const isPauseExperimentMutating = useIsMutating({
    mutationKey: ["pauseExperience"],
  });

  // no gating because you should always be able to end/pause
  return (
    <ActionExperienceButton
      isLoading={
        Boolean(
          isStartExperimentMutating ||
            isEndExperimentMutating ||
            isPauseExperimentMutating
        ) && rowExperience.id === currentExperience?.id
      }
      onClick={() => {
        onActionExpButtonClick(rowExperience);
      }}
      disabled={false}
      action={action}
      experience={rowExperience}
    />
  );
};
